import { CONTINUOUS_EDUCATION } from '../../../../../api/endpoints';
import request from '../../../../../api/request';
import { SectionV2 } from '../../../../../types/AcademicOffersType';
import { Campus } from '../../../../../types/campus';
import { PaginationRequestType } from '../../../../../types/paginationRequestType';
import { ScheduleV2 } from '../../../../../types/schedule';
import {
  SchoolType,
  Teacher,
} from '../../../../../types/sectionMaintainerTypes';
import { AssignOrCreateSectionPayload, CourseWithSection } from './types';

type FormDataResponseType = {
  teachers: Teacher[];
  schools: SchoolType[];
  campuses: Campus[];
  schedules: ScheduleV2[];
};

export function getCoursesWithSectionsFormData(ceAcademicOfferId: number) {
  return request<FormDataResponseType>(
    CONTINUOUS_EDUCATION.ACADEMIC_OFFER_COURSES_FORM(ceAcademicOfferId),
  );
}

/**
 * Obtiene las asignaturas del programa con sus secciones asignadas
 */
export const getOfferCoursesWithSections = (params: {
  ceAcademicOfferId: number;
  items_per_page: number;
  page: number;
}) => {
  return request<PaginationRequestType<CourseWithSection>>(
    CONTINUOUS_EDUCATION.ACADEMIC_OFFER_COURSES_WITH_SECTIONS(
      params?.ceAcademicOfferId,
    ),
    {
      params: params,
    },
  );
};

/**
 * Busca secciones CE disponibles para una asignatura
 */
export const getAvailableCeSections = (
  ceAcademicOfferId: number,
  courseId: number,
) => {
  return request<SectionV2[]>(
    CONTINUOUS_EDUCATION.AVAILABLE_CE_SECTIONS(ceAcademicOfferId, courseId),
    {
      method: 'GET',
      params: {},
    },
  );
};

/**
 * Asigna o crea una sección para una oferta CE
 */
export const assignOrCreateSection = (
  ceAcademicOfferId: number,
  courseId: number,
  payload: AssignOrCreateSectionPayload,
) => {
  return request<any>(
    CONTINUOUS_EDUCATION.ASSIGN_SECTION(ceAcademicOfferId, courseId),
    {
      method: 'POST',
      data: payload,
    },
  );
};

/**
 * Desasigna una sección de una oferta CE
 */
export const unassignSection = (
  ceAcademicOfferId: number,
  sectionId: number,
) => {
  return request(
    CONTINUOUS_EDUCATION.UNASSIGN_SECTION(ceAcademicOfferId, sectionId),
    {
      method: 'DELETE',
    },
  );
};
